import type { FinishedRun } from './data';

export interface WorkerWorkloadFacts {
  readonly finished: number;
  readonly succeeded: number;
  readonly failed: number;
  readonly successPercent: number;
}

/** Recent workload from the already-bounded finished-run read, matched by exact Worker id. */
export function workerWorkloadFacts(results: readonly FinishedRun[], workerId: string): WorkerWorkloadFacts | null {
  const mine = results.filter((result) => result.worker_id === workerId);
  if (mine.length === 0) return null;
  const succeeded = mine.filter((result) => result.success).length;
  const failed = mine.length - succeeded;
  return { finished: mine.length, succeeded, failed, successPercent: Math.round((succeeded / mine.length) * 100) };
}
